import {initWebComponent} from "@/helpers/web-component-helper";
import {showHideLayerGroups} from "@/helpers/context-menu-helper.js";

// https://itnext.io/handling-data-with-web-components-9e7e4a452e6e

export class LayerMenuGroupComponent extends HTMLElement{
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const depth = this.getAttribute('data-depth')
        const branch = window.branch[depth][key]
        const name = branch.label
        const template = document.createElement('template');

        // let px = 55
        // if(depth > 1) {
        //     px = 40
        // }

        let px = 33
        if(depth > 1) {
            px = 23
        }

        let rootClass= ''
        let style = 'font-weight:bold;'
        let floatRight = 'float-right'
        if(depth === "0") {
            floatRight = 'float-right'
            rootClass = 'accordion-group bg-lighter'
        } else {
            style = 'font-weight:bold;margin-left: ' + px + 'px;background-color: transparent;box-shadow: unset;'
        }

        // let isOpen =
        let ariaExpanded = 'false'
        let collapseShow = ''
        if(branch.open) {
            ariaExpanded = 'true'
            collapseShow = 'show'
        }

        let innerHtml = ''
        let merged = false
        if(branch.Type === 2) {
            merged = true
            // Hide the other group
            rootClass += ' d-none'

            // if(branch.parent === undefined) {
                let mergedKey = this.closest('layer-menu-group[data-depth="0"]').dataset.key

                if(!window.branchMerged[mergedKey]) {
                    window.branchMerged[mergedKey] = []
                }

                window.branchMerged[mergedKey][branch.ID] = branch
                innerHtml += `<layer-menu-group-merged data-label="${name}" data-depth="` + branch.ID + `" data-key="` + mergedKey + `"></layer-menu-group-merged>`
            // }
       }


        innerHtml += `<div class="card ` + rootClass + ` " style="` + style + `">
            <div class="card-header pl-2 pr-2">`

        let toggleGroupVisibility = ''
        if(!branch.checkbox) {
            toggleGroupVisibility = 'style="visibility: hidden"'
        }

        // innerHtml += `<layer-menu-button-toggle-group ${toggleGroupVisibility} data-parent-id="${depth}-${branch.ID}"></layer-menu-button-toggle-group>`

        innerHtml += `<a data-bs-toggle="collapse" data-bs-target="#collapse` + depth + `-` + branch.ID + `" class="layerMenuGroupToggleHeader accordion-header justify-content-between text-body collapsed" aria-expanded="` + ariaExpanded + `" href="#">
                <span class="fa fa-folder"></span>
                <span class="spnName" title="${name}">
                    ${name}
                </span>
                    <span class="${floatRight}">
                         <span class="collapse-icon"></span>     
                    </span>
                </a>
                
                <label class="custom-control custom-checkbox divCheckLayers">
                        <input type="checkbox" class="custom-control-input checkbox-group-item spnCheckLayers">
                        <span class="custom-control-label"></span>
                </label>
            </div>
            <div id="collapse` + depth + `-` + branch.ID + `" class="collapse ` + collapseShow + `">`
            branch.branch.map((branchItem, key) => {
                let childDepth = (parseInt(depth) + 1)
                if(window.branch[childDepth] === undefined) {
                    window.branch[childDepth] = []
                }
                window.branch[childDepth][key] = branchItem

                if(branchItem.folder === true) {
                    let layerMenuGroupChildClass = ''
                    if((parseInt(depth) + 1) > 0) {
                        layerMenuGroupChildClass = 'layer-menu-group-child'
                    }

                    if(branchItem.Type === 2) {
                        layerMenuGroupChildClass = ''
                    }
                    window.menuGroups.push(branchItem)
                    innerHtml += `<layer-menu-group data-id="${branchItem.ID}" data-label="${branchItem.label}" class="${layerMenuGroupChildClass}" data-depth="` + (parseInt(depth) + 1) + `" data-key="` + key + `"></layer-menu-group>`
                } else {
                    window.totalLayers++
                    innerHtml += `<layer-menu-group-item data-merged="${merged}" data-depth="` + (parseInt(depth) + 1) + `" data-key="` + key + `" data-parent-id="` + branch.ID +  `" data-checkbox="` + branch.checkbox +  `" data-id="` + branchItem.ID +  `" data-checked="` + branchItem.checked +  `" data-label="` + branchItem.label +  `"></layer-menu-group-item>`
                }
            })
        innerHtml += `</div></div>`;
        template.innerHTML = innerHtml

        initWebComponent(this, template)

        this.addEventListener('click', (element) => {
            if(element.target.classList.contains('spnCheckLayers')) {
                if(element.target.checked) {
                    showHideLayerGroups(element)
                } else {
                    showHideLayerGroups(element, false)
                }
            }
        })
    }
}
